import React, { PureComponent } from "react";
import Slider from "react-slick";

import { Icon } from '../../components';

import style from "./PageBanner.module.scss";

class PageBanner extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      currSlide: 0
    }
  }

  prevSlide = () => {
    if (this.slider) this.slider.slickPrev();
  }

  nextSlide = () => {
    if (this.slider) this.slider.slickNext();
  }

  render() {
    const { currSlide } = this.state;
    let { banner, data, sliders } = this.props;

    if (data != null) {
      let slider = data.about_slider
      banner = slider
    }

    if (sliders != null && sliders.length > 0) {
      let slides = sliders.map(el => {
        return {
          image: el.image && el.image.file_url
        }
      }).filter(el => el.image)

      banner = slides
    }

    if (!banner || !banner.length) {
      return null
    }

    let len = banner.length;
    const canSlide = len > 1;
    const settings = {
      adaptiveHeight: false,
      arrows: false,
      dots: false,
      // Non-infinite so the inactive arrow can show the designed disabled (white) state.
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      afterChange: (next) => this.setState({ currSlide: next })
    }

    const prevDisabled = currSlide === 0
    const nextDisabled = currSlide + 1 >= len

    return (
      <div className={style.container}>
        <div className={style.banner__container} id="page-slider">
          <Slider
            key={`page-banner-${len}`}
            ref={c => (this.slider = c)}
            {...settings}
          >
            {banner.map((_el, i) => {
              return (
                <div className={style.banner} key={`banner-${i}`}>
                  <img src={_el.image} className={style.banner__image} alt="" />
                </div>
              )
            })}
          </Slider>
        </div>
        {canSlide && (
          <div className={style.arrows__container}>
            <div className={`${style[`arrows__container--inner`]}`}>
              <div
                className={`${style.arrow} ${prevDisabled && style[`arrow-disabled`]}`}
                onClick={() => { if (!prevDisabled) this.prevSlide() }}
              >
                <Icon type={prevDisabled ? "left" : "leftwhite"} className={style.arrow__icon} />
              </div>
              <div
                className={`${style.arrow} ${nextDisabled && style[`arrow-disabled`]}`}
                onClick={() => { if (!nextDisabled) this.nextSlide() }}
              >
                <Icon type={nextDisabled ? "right" : "rightwhite"} className={style.arrow__icon} />
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default PageBanner;
